import { useEffect, useState } from "react";

interface PageTransitionReturn {
  isMounted: boolean;
  transitionClasses: string;
}

export const usePageTransition = (): PageTransitionReturn => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMounted(true);
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  const transitionClasses = `tw-transition-opacity tw-duration-500 tw-ease-in-out ${
    isMounted ? "tw-opacity-100" : "tw-opacity-0"
  }`;

  return {
    isMounted,
    transitionClasses,
  };
};
